"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const is_empty_1 = __importDefault(require("../../utils/is-empty"));
const message_defaults_json_1 = __importDefault(require("../../message-defaults.json"));
const messageDefault = message_defaults_json_1.default.password;
const validationBuilder = (message) => {
    const getMessage = (key) => lodash_1.default.get(message, key, messageDefault[key]);
    return (value) => {
        if (!(0, is_empty_1.default)(value) && lodash_1.default.isString(value)) {
            if (value.length < 10) {
                return getMessage('short');
            }
            if (!value.match(/\d/)) {
                return getMessage('number');
            }
            if (!value.match(/[a-z]/i)) {
                return getMessage('letter');
            }
        }
        return null;
    };
};
validationBuilder.messageDefault = messageDefault;
exports.default = validationBuilder;
